export const sleep = (time: number) => new Promise((r) => setTimeout(r, time));
